import api from "core/api/api";
import App from "app";
import navigateTo from "src/navigate-to";
import metaobjectConverter from "core/services/metaStoreService/metaobject-converter";
import statusManagement from "src/status-management";

export const dropApplication = async (appName: string, currentModule: string) => {
    let status: string | undefined;
    try {
        status = await api.getApplicationStatus(appName);
    } catch (statusError) {
        console.warn("could not fetch app status before drop, attempting stop and undeploy", statusError);
    }

    if (status && statusManagement.isTransientStatus(status)) {
        throw new Error(
            `Cannot drop '${appName}' — it is currently ${statusManagement.getStatusDisplayName(
                status
            )}. Wait for it to settle and try again.`
        );
    }

    const isCreated = status ? statusManagement.isApplicationCreated(status) : false;
    const isRunning = status ? statusManagement.isApplicationRunning(status) : true;

    if (!isCreated && isRunning) {
        try {
            await api.stopApp(appName);
        } catch (stopError) {
            console.warn("stop before undeploy failed, continuing to undeploy", stopError);
        }
    }

    if (!isCreated) {
        try {
            await api.undeploy(appName);
        } catch (undeployError) {
            console.warn("undeploy before drop failed, continuing to drop", undeployError);
        }
    }

    const result = await api.compileTQL(`DROP APPLICATION ${appName} CASCADE;`);
    App.vent.trigger("compilation-needed");
    App.vent.trigger("app:deleted", metaobjectConverter.toTypedId(appName, "APPLICATION"));
    if (currentModule === "flow") {
        navigateTo.Apps();
    }
    return result;
};
